import './freepro.css';
import { Button} from '@mui/material';
import {NavLink} from 'react-router-dom';
const Freepro=()=>{
    return(
      <>
           <div className="container-fluid">
           <div className="row">
               <div className="col-md-12 hero-bg-sign">
                  <div className="hero-shadow-box">
                    <div>
                    <h1>Project Currently In Progress...</h1>
                     <p className='text-start text-capitalize'>soon You will start <br /> getting projects.</p>
                      <NavLink to='/'><Button variant='contained'> <i class="fa-solid fa-circle-arrow-left fs-5"></i>&nbsp; Back to homepage</Button></NavLink>
                    </div>
                  </div>
               </div>
           </div>
        </div>
   </>
    )
}
export default Freepro;